"use strict";
// This file is auto generated by bin/create-constants.js
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  ADD: 'add',
  ALIGNCENTER: 'alignCenter',
  ALIGNJUSTIFY: 'alignJustify',
  ALIGNLEFT: 'alignLeft',
  ALIGNRIGHT: 'alignRight',
  ALIGN_CENTER: 'alignCenter',
  ALIGN_JUSTIFY: 'alignJustify',
  ALIGN_LEFT: 'alignLeft',
  ALIGN_RIGHT: 'alignRight',
  ANCHOR: 'anchor',
  ANGLE_DOUBLE_LEFT: 'previous',
  ANGLE_DOUBLE_RIGHT: 'next',
  ANGLE_LEFT: 'left',
  ARCHIVE: 'archive',
  ATTACH: 'attach',
  BACKGROUNDCOLOR: 'backgroundColor',
  BLANK: 'blank',
  BLOCK: 'block',
  BLOCK_FACEBOOK: 'socialBlockFacebook',
  BLOCK_GOOGLE_PLUS: 'socialBlockGoogleplus',
  BLOCK_LINKEDIN: 'socialBlockLinkedin',
  BLOCK_PINTEREST: 'socialBlockPinterest',
  BLOCK_RSS: 'socialBlockRss',
  BLOCK_TWITTER: 'socialBlockTwitter',
  BLOCK_XING: 'socialBlockXing',
  BLOCK_YOUTUBE: 'socialBlockYoutube',
  BLOCK_YOUTUBE_PLAY: 'socialBlockYoutubeplay',
  BLOG: 'blog',
  BOLD: 'bold',
  BOOK: 'book',
  BUBBLE: 'bubble',
  BUILDING_O: 'companies',
  BULB: 'bulb',
  BULLETCIRCLE: 'bulletCircle',
  BULLETDIAMOND: 'bulletDiamond',
  BULLETLIST: 'bulletList',
  BULLETLOWERALPHA: 'bulletLowerAlpha',
  BULLETLOWERGREEK: 'bulletLowerGreek',
  BULLETLOWERROMAN: 'bulletLowerRoman',
  BULLETSQUARE: 'bulletSquare',
  BULLETUPPERALPHA: 'bulletUpperAlpha',
  BULLETUPPERROMAN: 'bulletUpperRoman',
  CALENDAR: 'date',
  CALL: 'calling',
  CALLING: 'calling',
  CALLINGHANGUP: 'callingHangup',
  CALLINGMADE: 'callingMade',
  CALLINGMISSED: 'callingMissed',
  CALLTRANSCRIPT: 'callTranscript',
  CAP: 'cap',
  CART: 'cart',
  CASE: 'case',
  CERTIFICATION: 'certification',
  CHAIN: 'link',
  CHECK: 'success',
  CHECK2: 'success',
  CLEAR_FORMATTING: 'eraseStyles',
  CLOCK: 'time',
  CLOCK2: 'time',
  CLOSE: 'remove',
  CLOUD_UPLOAD: 'upload',
  CODE: 'code',
  COLUMN: 'column',
  COMMENTS: 'comments',
  COMMENTS_O: 'comments',
  COMMENT_O: 'comments',
  COMPANIES: 'companies',
  CONDITIONAL: 'conditional',
  CONTACT: 'contacts',
  CONTACTPROPERTIES: 'contactProperties',
  CONTACTS: 'contacts',
  CONTACTS2: 'contacts',
  COPY: 'duplicate',
  CROSS2: 'remove',
  CSSFILE: 'cssFile',
  CTAS: 'ctas',
  CTA_CLICK: 'ctas',
  CUSTOMHUBL: 'customHubl',
  CUSTOMMODULES: 'customModules',
  DATABASES: 'databases',
  DATE: 'date',
  DEAL: 'deals',
  DEALS: 'deals',
  DEBUG: 'debug',
  DEDENT: 'outdent',
  DELAY: 'delay',
  DELETE: 'delete',
  DESCRIPTION: 'description',
  DESKTOP: 'desktop',
  DIFF: 'diff',
  DOCUMENT: 'documents',
  DOCUMENTS: 'documents',
  DOWN: 'down',
  DOWNCARAT: 'downCarat',
  DOWNLOAD: 'download',
  DOWN_ANGLE: 'down',
  DOWN_ARR: 'down',
  DRAGANDDROPLAYOUT: 'dragAndDropLayout',
  DRAGHANDLE: 'dragHandle',
  DROPBOX: 'dropbox',
  DUPLICATE: 'duplicate',
  EDIT: 'edit',
  EDITCOLUMNS: 'editColumns',
  ELLIPSES: 'ellipses',
  EMAIL: 'email',
  EMAILOPEN: 'emailOpen',
  EMAIL_OPEN: 'emailOpen',
  EMBED: 'embed',
  EMBED2: 'code',
  EMOJI: 'emoji',
  EMOJIFILLHAPPY: 'emojiFillHappy',
  EMOJIFILLNEUTRAL: 'emojiFillNeutral',
  EMOJIFILLSAD: 'emojiFillSad',
  EMOJILINENEUTRAL: 'emojiLineNeutral',
  EMOJILINESAD: 'emojiLineSad',
  ENLARGE: 'enlarge',
  ENROLL: 'enroll',
  ERASER: 'eraseStyles',
  ERASESTYLES: 'eraseStyles',
  EXCLAMATION: 'exclamation',
  EXITFULLSCREEN: 'exitFullScreen',
  EXPAND: 'expand',
  EXTERNALLINK: 'externalLink',
  EXTERNAL_LINK: 'externalLink',
  EYE: 'view',
  EYE_SLASH: 'hide',
  FACEBOOK: 'socialFacebook',
  FAVORITE: 'favorite',
  FAVORITEHOLLOW: 'favoriteHollow',
  FILE: 'file',
  FILE_TEXT: 'file',
  FILTER: 'filter',
  FIRST: 'first',
  FLEXCOLUMN: 'flexColumn',
  FOLDER: 'folder',
  FOLDEROPEN: 'folderOpen',
  FOLDER_OPEN: 'folderOpen',
  FONT: 'textColor',
  FONTFILE: 'fontFile',
  FOOTER: 'footer',
  FORM: 'forms',
  FORMS: 'forms',
  FULLWIDTH: 'fullWidth',
  GAUGE: 'gauge',
  GDDC: 'gddc',
  GEAR: 'settings',
  GENERATECHART: 'generateChart',
  GHOST: 'ghost',
  GIFT: 'gift',
  GITHUB: 'github',
  GLOBALGROUP: 'globalGroup',
  GLOBE: 'language',
  GOAL: 'goal',
  GOOGLE: 'socialGoogle',
  GOOGLE_DRIVE: 'socialGoogleDrive',
  GOOGLE_DRIVE2: 'socialGoogleDrive',
  GOOGLE_PLUS: 'socialGoogleplus',
  GOOGLE_PLUS2: 'socialGoogleplus',
  GRID: 'grid',
  GROUPMODULE: 'groupModule',
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  HAMBURGER: 'listView',
  HANDSHAKE: 'deals',
  HEADER: 'header',
  HELP_WITH_CIRCLE: 'info',
  HIDE: 'hide',
  HIGHLIGHT: 'highlight',
  HORIZONTALRULE: 'horizontalRule',
  HSDESIGNCERT: 'hsDesignCert',
  HTMLFILE: 'htmlFile',
  HUBDB: 'hubDB',
  HUBSPOTCERTIFICATION: 'hubspotCertification',
  IMAGEALIGNMENTLEFT: 'imageAlignmentLeft',
  IMAGEALIGNMENTMIDDLE: 'imageAlignmentMiddle',
  IMAGEALIGNMENTRIGHT: 'imageAlignmentRight',
  IMAGEALIGNMENTTOP: 'imageAlignmentTop',
  IMAGEGALLERY: 'imageGallery',
  INBOX: 'inbox',
  INDENT: 'indent',
  INFO: 'info',
  INLINE: 'inline',
  INSERTIMAGE: 'insertImage',
  INSERTQUOTE: 'insertQuote',
  INSERTVIDEO: 'insertVideo',
  INTEGRATIONS: 'integrations',
  INTEGRATIONSSALESFORCE: 'integrationsSalesForce',
  INTEGRATIONSSURVEYMONKEY: 'integrationsSurveyMonkey',
  ITALIC: 'italic',
  JSFILE: 'jsFile',
  KEY: 'key',
  LANGUAGE: 'language',
  LAST: 'last',
  LEFT: 'left',
  LEFT_ANGLE: 'left',
  LEFT_ARR: 'left',
  LEFT_ARROW: 'previous',
  LESSON: 'lesson',
  LINEHEIGHT: 'lineHeight',
  LINK: 'link',
  LINKEDIN: 'socialLinkedin',
  LISTS: 'lists',
  LISTVIEW: 'listView',
  LIST_OL: 'numberList',
  LIST_UL: 'bulletList',
  LOCATION: 'location',
  LOCK: 'locked',
  LOCKED: 'locked',
  LOGO: 'logo',
  MAIL: 'email',
  MAIL_DARK: 'email',
  MEETINGS: 'meetings',
  MENU: 'menu',
  MERGE: 'merge',
  MESSAGES: 'messages',
  MICROPHONE: 'record',
  MINUS: 'minus',
  MOBILE: 'mobile',
  MOVE: 'move',
  NEWSPAPER: 'blog',
  NEXT: 'next',
  NONBREAKINGSPACE: 'nonbreakingSpace',
  NOTEDITABLE: 'notEditable',
  NOTIFICATION: 'notification',
  NUMBERLIST: 'numberList',
  OFFICE365: 'office365',
  OUTDENT: 'outdent',
  PAIDAD: 'paidAd',
  PARAGRAPH: 'paragraph',
  PARTIAL: 'partial',
  PDFFILE: 'pdfFile',
  PEN: 'signature',
  PENCIL: 'edit',
  PHONE: 'calling',
  PHOTO: 'insertImage',
  PIN: 'pin',
  PINTEREST: 'socialPinterest',
  PLAYERFASTFORWARD: 'playerFastForward',
  PLAYERPAUSE: 'playerPause',
  PLAYERPLAY: 'playerPlay',
  PLAYERREWIND: 'playerRewind',
  PLUS: 'add',
  POPOUT: 'popOut',
  PRESENTATION: 'presentation',
  PREVIOUS: 'previous',
  PRICE_TAG: 'tag',
  PRODUCT: 'product',
  QUESTION: 'question',
  QUESTIONANSWER: 'questionAnswer',
  QUOTES_LEFT: 'insertQuote',
  READMORE: 'readMore',
  RECORD: 'record',
  REDO: 'redo',
  REFRESH: 'refresh',
  REMOVE: 'remove',
  REMOVETEXTSTYLE: 'removeTextStyle',
  REPLACE: 'replace',
  REPLY: 'reply',
  REPLYALL: 'replyAll',
  REPORTSPAM: 'reportSpam',
  RICHTEXT: 'richText',
  RIGHT: 'right',
  RIGHT_ARR: 'right',
  RIGHT_ARROW: 'next',
  ROTATE: 'rotate',
  ROTATELEADS: 'rotateLeads',
  ROW: 'row',
  RSS: 'socialRss',
  SALESTEMPLATES: 'salesTemplates',
  SEARCH: 'search',
  SECTION: 'section',
  SECTIONHEADER: 'sectionHeader',
  SEND: 'send',
  SEQUENCES: 'sequences',
  SETTINGS: 'settings',
  SHARE: 'share',
  SIGNATURE: 'signature',
  SIMPLEBOT: 'simpleBot',
  SMS: 'sms',
  SOCIAL: 'social',
  SOCIALBLOCKFACEBOOK: 'socialBlockFacebook',
  SOCIALBLOCKGOOGLEPLUS: 'socialBlockGoogleplus',
  SOCIALBLOCKINSTAGRAM: 'socialBlockInstagram',
  SOCIALBLOCKLINKEDIN: 'socialBlockLinkedin',
  SOCIALBLOCKPINTEREST: 'socialBlockPinterest',
  SOCIALBLOCKRSS: 'socialBlockRss',
  SOCIALBLOCKTWITTER: 'socialBlockTwitter',
  SOCIALBLOCKXING: 'socialBlockXing',
  SOCIALBLOCKYOUTUBE: 'socialBlockYoutube',
  SOCIALBLOCKYOUTUBEPLAY: 'socialBlockYoutubeplay',
  SOCIALFACEBOOK: 'socialFacebook',
  SOCIALFACEBOOKMESSENGER: 'socialFacebookMessenger',
  SOCIALGOOGLE: 'socialGoogle',
  SOCIALGOOGLEDRIVE: 'socialGoogleDrive',
  SOCIALGOOGLEPLUS: 'socialGoogleplus',
  SOCIALHEART: 'socialHeart',
  SOCIALINSTAGRAM: 'socialInstagram',
  SOCIALJIRA: 'socialJira',
  SOCIALLINKEDIN: 'socialLinkedin',
  SOCIALPINTEREST: 'socialPinterest',
  SOCIALRETWEET: 'socialRetweet',
  SOCIALRSS: 'socialRss',
  SOCIALSLACK: 'socialSlack',
  SOCIALTWITTER: 'socialTwitter',
  SOCIALWHATSAPP: 'socialWhatsapp',
  SOCIALXING: 'socialXing',
  SOCIALYOUTUBE: 'socialYoutube',
  SOCIALYOUTUBEPLAY: 'socialYoutubeplay',
  SORTALPASC: 'sortAlpAsc',
  SORTALPDESC: 'sortAlpDesc',
  SORTAMTASC: 'sortAmtAsc',
  SORTAMTDESC: 'sortAmtDesc',
  SORTNUMASC: 'sortNumAsc',
  SORTNUMDESC: 'sortNumDesc',
  SPACER: 'spacer',
  SPECIALCHARACTER: 'specialCharacter',
  SPELLCHECK: 'spellCheck',
  SPLITMODULE: 'splitModule',
  SPROCKET: 'sprocket',
  STAR: 'favorite',
  STAR_O: 'favorite',
  STOPRECORD: 'stopRecord',
  STRIKE: 'strike',
  STYLES: 'styles',
  SUBSCRIPT: 'subscript',
  SUCCESS: 'success',
  SUPERSCRIPT: 'superscript',
  SWITCHER: 'switcher',
  TABLE: 'table',
  TABLET: 'tablet',
  TAG: 'tag',
  TASKS: 'tasks',
  TEST: 'test',
  TEXT: 'text',
  TEXTCOLOR: 'textColor',
  TEXTSNIPPET: 'textSnippet',
  THEME: 'theme',
  THEMEFILE: 'themeFile',
  THUMBSDOWN: 'thumbsDown',
  THUMBSUP: 'thumbsUp',
  TICKET: 'ticket',
  TIME: 'time',
  TRASH: 'delete',
  TRASH2: 'delete',
  TROPHY: 'trophy',
  TWITTER: 'socialTwitter',
  TWOFAFILL: 'twoFAFill',
  TWOFAOUTLINE: 'twoFAOutline',
  UNDERLINE: 'underline',
  UNDO: 'undo',
  UNLINK: 'unlink',
  UNLOCKED: 'unlocked',
  UP: 'up',
  UPCARAT: 'upCarat',
  UPLOAD: 'upload',
  UPLOAD_DARK: 'upload',
  UPLOAD_LIGHT: 'upload',
  UP_ANGLE: 'up',
  UP_ARR: 'up',
  USER: 'contacts',
  VIDEOFILE: 'videoFile',
  VIEW: 'view',
  VOLUME: 'volume',
  VOLUMEDOWN: 'volumeDown',
  VOLUMEMUTE: 'volumeMute',
  VOLUMEUP: 'volumeUp',
  VOLUME_DOWN: 'volumeDown',
  VOLUME_OFF: 'volumeMute',
  VOLUME_UP: 'volumeUp',
  WALLET: 'wallet',
  WARNING: 'warning',
  WARNING_TRIANGLE: 'warning',
  WEBSITE: 'website',
  WORKFLOWS: 'workflows',
  X: 'remove',
  XING: 'socialXing',
  XMLFILE: 'xmlFile',
  YOUTUBE: 'socialYoutube',
  YOUTUBE_PLAY: 'socialYoutubeplay',
  ZOOMIN: 'zoomIn',
  ZOOMOUT: 'zoomOut',
  ZOOM_IN: 'zoomIn',
  ZOOM_OUT: 'zoomOut'
};
exports.default = _default;
module.exports = exports.default;